<template>
  <div id="app">
    <router-view></router-view>
    <toast-notification />
    <disabled-freshworks-widget v-if="!showFreshdeskWidget" />
    <file-download-notification />
  </div>
</template>

<script>
import ToastNotification from './components/common/ToastNotification'
import DisabledFreshworksWidget from './components/common/DisabledFreshdeskWidget'
import { mapState } from 'vuex'
import FileDownloadNotification from './components/common/FileDownloadNotification'

export default {
  computed: {
    ...mapState({
      showFreshdeskWidget: (state) => state.root.showFreshdeskWidget
    })
  },
  components: {
    ToastNotification,
    DisabledFreshworksWidget,
    FileDownloadNotification
  },
  name: 'App'
}
</script>
